import React from 'react';

import { useStormTradeParticipantListInfiniteQuery } from '@query';

import StepsToJoinCampaign from '../StepsToJoinCampaign';
import { stepsToJoinStormTradeCampaign } from './data';

const StepsToJoinStormTradeCampaign = () => {
  const { data } = useStormTradeParticipantListInfiniteQuery();
  const campaignUrl = data?.pages[0]?.meta.campaign || '#';

  return <StepsToJoinCampaign campaignUrl={campaignUrl} steps={stepsToJoinStormTradeCampaign} />;
};

export default StepsToJoinStormTradeCampaign;
